export interface DuplicateConfirmationRecord {
  id: string
  account_id: string
  account_name: string | null
  create_date: string | null
}

export function isDuplicateConfirmationError(err: any): err is {
  response: {
    status: 409
    data: {
      result?: { message?: string }
      data: { duplicates: DuplicateConfirmationRecord[] }
    }
  }
} {
  return (
    err?.response?.status === 409 &&
    Array.isArray(err?.response?.data?.data?.duplicates) &&
    err.response.data.data.duplicates.length > 0
  )
}

export default class DuplicateConfirmationError extends Error {
  duplicates: DuplicateConfirmationRecord[]
  payloadMessage: string

  constructor(duplicates: DuplicateConfirmationRecord[], message: string) {
    super(message)
    this.name = 'DuplicateConfirmationError'
    this.duplicates = duplicates
    this.payloadMessage = message
  }
}
